import { render, staticRenderFns } from "./InputWrap.vue?vue&type=template&id=70d3148d&scoped=true"
import script from "./InputWrap.vue?vue&type=script&lang=js"
export * from "./InputWrap.vue?vue&type=script&lang=js"
import style0 from "./InputWrap.vue?vue&type=style&index=0&id=70d3148d&prod&lang=less&scoped=true"
import style1 from "./InputWrap.vue?vue&type=style&index=1&id=70d3148d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d3148d",
  null
  
)

export default component.exports